import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        ok: '&',
        cancel: '&'
    },
    template: `
    <div class="modal-header">
        <button type="button" class="close" ng-click="vm.cancel()"></button>
        <h2>{{ 'metaField.Add meta group' | translate }}</h2>
    </div>
    <form ng-submit="vm.save()">
        <div class="modal-body">
            <div class="form">
                <forms-settings-meta-group-generaldata form="vm.form"></forms-settings-meta-group-generaldata>
            </div>
        </div>
        <div class="modal-footer" >
            <ul class="actions01">
                <li ng-if="vm.QuestionService.canManageQuestionRelatedData()" class="primary"><input type="submit" class="btn main" value="{{ 'general.Save' | translate }}"/></li>
                <li><button class="btn discrete" type="button" ng-click="vm.cancel()">{{ 'general.Cancel' | translate }}</button></li>
            </ul>
        </div>
    </form>
    `
})
export default class {
    constructor (FormFactory, MetaFieldGroupResource, QuestionService) {
        this.QuestionService = QuestionService;
        this.form = FormFactory.create(new MetaFieldGroupResource, model => model.$save());
    }

    save () {
        this.form.save()
            .then(() => {
                this.ok();
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/settings/meta/group/add/index.js